export const selectBookings = (state) => state.bookings
